import { Euler } from "three"
import { pinMass } from "../../constants"
import * as CANNON from "cannon-es"

export default class WorldPin {
  constructor(world, material) {
    this.world = world

    this.shape = new CANNON.Box(new CANNON.Vec3(.5, 1.5, .5))
    this.body = new CANNON.Body({ material, mass: pinMass })
    this.body.addShape(this.shape)

    this.world.addBody(this.body)
    // this.world.bodies.push(this.body)
  }

  bindToMesh({mesh}) {
    this.mesh = mesh
    this.body.position.set(mesh.position.x, mesh.position.y + 5, mesh.position.z)
  }

  update() {
    // console.log(this.mesh.position)
    this.mesh.position.set(this.body.position.x, this.body.position.y, this.body.position.z)
    const rotation = new CANNON.Vec3(0,0,0)
    this.body.quaternion.toEuler(rotation, 'YZX')
    this.mesh.setRotationFromEuler(new Euler(...Object.values(rotation), 'YZX'))
  }
}